<template>
  <div
    class="project-header project-inner w-nav"
    :style="{
      'background-color': project && project.color ? project.color : DEFAULT_COLOR,
    }"
  >
    <div class="header-container">
      <div v-if="project" class="left-part spacex-12">
        <SidebarOpener />
        <router-link v-if="isTenderList" :to="projectSummaryRoute">
          <BackIcon class="icon-14px white-icon-btn" />
        </router-link>
        <div class="text text-bold text-mr8 no-wrap text-header flex-centering spacex-12">
          <router-link tag="span" class="pointer" :to="projectSummaryRoute">
            {{ project.name }}
          </router-link>
          <div v-if="project.status === 'archived'" class="text text-white no-wrap fs-14 fw-5">
            {{ $t('Archived') }}
          </div>
          <span v-if="isTenderList"> – {{ $t('All tenders') }}</span>
        </div>
        <Button
          v-if="changesCount"
          type="secondary"
          left-icon="alert-triangle"
          size="small"
          overlay
          @click="openChangesModal"
        >
          {{ changesInfo }}
        </Button>
        <Button
          v-else
          type="secondary"
          left-icon="check"
          size="small"
          overlay
          @click="openChangesModal"
        >
          {{ $t('All published') }}
        </Button>
      </div>

      <div class="right-part">
        <AvatarList
          v-if="project && project.team"
          :team="project.team"
          :project-id="$route.params.id"
          @open-members="openProjectSettings"
        />

        <SettingsDropdown :project="project" @refresh="$emit('refresh-project-info')" />
      </div>
    </div>
    <div class="w-nav-overlay" />
  </div>
</template>

<script>
  import { DEFAULT_COLOR } from '@/utils/constants/common';
  import SettingsDropdown from '@/containers/top-menu/header/project-settings/SettingsDropdown';
  import AvatarList from '@/components/avatars/AvatarList';
  import SidebarOpener from '@/containers/top-menu/SidebarOpener';
  import { mapActions } from 'vuex';
  import BackIcon from '@/assets/icons/arrow-left-black.svg';
  import Button from '@/components/ui-v2/Button';
  import ProjectChangesModal from '@/containers/project/ProjectChangesModal';
  import projectChangesCount from '@/gql/projects/project-changes.graphql';
  import ProjectSettingsModal from '@/containers/top-menu/header/project-settings/Modal';

  export default {
    name: 'ProjectHeader',
    components: {
      SidebarOpener,
      AvatarList,
      SettingsDropdown,
      BackIcon,
      Button,
    },
    apollo: {
      $subscribe: {
        changes() {
          return {
            query: projectChangesCount,
            variables() {
              return {
                id: this.project.id,
              };
            },
            result({ data }) {
              this.changesCount = data.project_change_aggregate.aggregate.count;
            },
          };
        },
      },
    },
    meta() {
      if (this.project)
        return {
          title: `${this.project.name} — Fixtender`,
        };
    },
    props: {
      project: Object,
      isTenderList: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        DEFAULT_COLOR,
        changesCount: 0,
      };
    },
    computed: {
      projectSummaryRoute() {
        return {
          name: 'project',
          params: { id: this.project.id },
        };
      },
      changesInfo() {
        return `${this.changesCount} ${this.$t('unpublished')} ${this.$tc(
          'change',
          this.changesCount
        )}`;
      },
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
      }),
      openProjectSettings() {
        this.openModal({
          component: ProjectSettingsModal,
          context: {
            step: 3,
            createForm: false,
            projectId: this.project?.id,
            attributes: {
              class: 'create-tender__container',
            },
            update: () => {
              this.$emit('deleteProject');
            },
          },
        });
      },
      openChangesModal() {
        this.openModal({
          component: ProjectChangesModal,
          context: {
            projectId: this.project.id,
            project: this.project,
            attributes: {
              class: ['create-tender__container'],
            },
          },
        });
      },
    },
  };
</script>
